import env from "env";
import { BackLinkType } from "./types";

export const Roles = {
  Member: "Member",
  EnterpriseAdmin: "EnterpriseAdmin",
  EnterpriseSalesTeamMember: "EnterpriseSalesTeamMember",
  EnterprisePaymentOperation: "EnterprisePaymentOperation",
  EnterpriseBankAdmin: "EnterpriseBankAdmin",
  EnterpriseDeveloper: "EnterpriseDeveloper",
};

export const MerchantViewRef = {
  PAYMENT_HISTORY: "payment-history",
  PAYMENT_DETAIL: "payment-detail",
  MERCHANT_LIST: "merchant-list",
  TPPP_MERCHANT_LIST: "tppp-merchant",
  TPPP_LIST: "tppp-list",
  RECONCILIATION: "reconciliation",
  RECONCILIATION_SUMMARIES: "view-reconciliation-summary",
  TRANSACTION_HISTORY: "transaction-history",
};

export enum PaymentMethod {
  NORMAL_PAY = "NormalPay",
  EARLY_PAY = "EarlyPay",
}

export enum AccountStatus {
  ACTIVE = "Active",
  DISABLED = "Disabled",
  SUSPENDED = "Suspended",
  PENDING = "Pending",
}

export enum PaymentStatus {
  ALL = "All",
  INITIALIZED = "Initialized",
  COMPLETED = "Completed",
  PENDING = "Pending",
  ACCEPTEDSETTLEMENTINPROCESS = "AcceptedSettlementInProcess",
  ACCEPTEDCREDITSETTLEMENTCOMPLETED = "AcceptedCreditSettlementCompleted",
  ACCEPTEDSETTLEMENTCOMPLETED = "AcceptedSettlementCompleted",
  ACCEPTEDWITHOUTPOSTING = "AcceptedWithoutPosting",
  CANCELLED = "Cancelled",
  FAILED = "Failed",
  ERROR = "Error",
  REJECTED = "Rejected",
}

export const DataLoaderDataSets = {
  DAKKO_PAYSLIP_DS: env.app.dataSetDakkoPayslipDs,
  PAYROLL_DS: env.app.dataSetPayrollDs,
  TPPP_MERCHANT: env.app.dataSetTpppMerchant,
  TPPP_TRANSACTION_RECON_DATA: env.app.dataSetTransaction

};

export enum DataLoaderUploadStatuses {
  UPLOADED = "UPLOADED",
  PROCESSING = "PROCESSING",
  PARTIAL = "PARTIAL",
  SUCCESS = "SUCCESS",
  FAILED = "FAIL",
}

export enum ApprovalTaskStatues {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
  IGNORED = "IGNORED",
  PROCESSING = "PROCESSING",
}

export enum ApprovalAction {
  PROCESSED = "processed",
  DECLINED = "declined",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;

export enum AntiVirusStatuses {
  SCANNING = "SCANNING",
  SAFE = "SAFE",
  INFECTED = "INFECTED",
}

export const StatusOptions = [
  {
    value: AccountStatus.ACTIVE,
    label: AccountStatus.ACTIVE,
  },
  {
    value: AccountStatus.DISABLED,
    label: AccountStatus.DISABLED,
  },
  {
    value: AccountStatus.SUSPENDED,
    label: AccountStatus.SUSPENDED,
  },
];

export const RoleOptions = [
  {
    value: Roles.EnterpriseBankAdmin,
    label: "Enterprise Bank Admin",
    data: { title: "Enterprise Bank Admin", userGuide: "enterpriseBankAdmin", homepage: '/tppp-list-view' },
  },
  {
    value: Roles.EnterpriseAdmin,
    label: "Enterprise Admin",
    data: { title: "Enterprise Admin", userGuide: "enterpriseAdmin", homepage: '/active-collaborators'},
  },
  {
    value: Roles.EnterprisePaymentOperation,
    label: "Payment Operation",
    data: { title: "Payment Operation", userGuide: "enterprisePaymentOperation", homepage: '/payment-history-view' },
  },
  {
    value: Roles.EnterpriseSalesTeamMember,
    label: "Sales Team Member",
    data: { title: "Sales Team Member", userGuide: "enterpriseSalesTeamMember", homepage: '/tppp-list-view' },
  },
  {
    value: Roles.EnterpriseDeveloper,
    label: "Enterprise Developer",
    data: { title: "Enterprise Developer", userGuide: "enterpriseDeveloper", homepage: '/active-collaborators' },
  },
  {
    value: Roles.Member,
    label: "TPPP Member",
    data: { title: "TPPP Member" },
  },
];

export const nameScreeningLevelOptions = [
  {
    value: "High",
    label: "High",
  },
  {
    value: "Medium",
    label: "Medium",
  },
  {
    value: "Low",
    label: "Low",
  },
];

export const genderOptions = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const BackLink: BackLinkType = {
  [MerchantViewRef.MERCHANT_LIST]: {
    label: "Back to View Merchant List",
    to: "/tppp-merchants-view",
  },
  [MerchantViewRef.PAYMENT_HISTORY]: {
    label: "Back to View Payment History",
    to: "/payment-history-view",
  },
  [MerchantViewRef.PAYMENT_DETAIL]: {
    label: "Back to View Payment Details",
    to: "/payment-detail",
  },
  [MerchantViewRef.TPPP_MERCHANT_LIST]: {
    label: "Back to TPPP Merchant List",
    to: "/tppp-detail-view",
    tabIndex: 2,
  },
  [MerchantViewRef.TPPP_LIST]: {
    label: "Back to TPPP List",
    to: "/tppp-list-view",
    tabIndex: 2,
  },
  [MerchantViewRef.RECONCILIATION]: {
    label: "Back to View Reconciliation Batches",
    to: "/reconciliation",
  },
  [MerchantViewRef.RECONCILIATION_SUMMARIES]: {
    label: "Back to View Reconciliation Summary",
    to: "/view-reconciliation-summary"
  },
   [MerchantViewRef.TRANSACTION_HISTORY]: {
    label: "Back to View Transaction History",
    to: "/view-transaction-history",
  },
};
